import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export default function MobileTbmSessions({ sessions, getStatusMeta, disabled, onCreate, onEdit }) {
  if (!sessions.length) return <Typography color="text.secondary" sx={{ py: 3, textAlign: "center" }}>해당 조건의 TBM 기록이 없습니다.</Typography>;
  return <Stack spacing={1} aria-label="선택 날짜 팀별 TBM 목록">
    {sessions.map((session) => {
      const status = getStatusMeta(session.status);
      return <Box component="article" key={session.id} aria-label={session.team_name || "팀 미지정"}
        sx={{ p: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1, bgcolor: "background.paper" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <Typography sx={{ overflowWrap: "anywhere", fontSize: 14 }}>{session.team_name || "팀 미지정"}</Typography>
          <Chip size="small" label={status.label} color={status.color} sx={{ flexShrink: 0 }} />
        </Stack>
        <Box component="dl" sx={{ m: 0, my: 1.25, display: "grid", gridTemplateColumns: "auto minmax(0, 1fr)", gap: "4px 16px", fontSize: 13, "& dt": { color: "text.secondary" }, "& dd": { m: 0, overflowWrap: "anywhere" } }}>
          <dt>진행자</dt><dd>{session.leader_name || "-"}</dd>
          <dt>실시 시간</dt><dd>{session.session_time || "-"}</dd>
          <dt>참석</dt><dd>{session.attended_count || 0} / {session.total_members || 0}명</dd>
        </Box>
        <Button fullWidth variant="outlined" startIcon={<EditOutlinedIcon />} disabled={disabled}
          onClick={() => session.virtual ? onCreate(session) : onEdit(session)}>
          {session.virtual ? "등록" : "상세/수정"}
        </Button>
      </Box>;
    })}
  </Stack>;
}
